module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Item Lote ' + this.parent.formData.lote,
      "modal": _vm.showFormList,
      "width": "98%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [(_vm.parent.formData.lote) ? _c('eSocial', {
    key: _vm.formData.id + '-' + (_vm.showForm ? 1 : 0),
    attrs: {
      "layout": _vm.parent.formData.layout,
      "lote": _vm.parent.formData.lote,
      "avulso": _vm.parent.formData.avulso ? _vm.parent.formData.avulso : 0
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03e57592"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/lotes/item/index.vue
// module id = 1400
// module chunks = 45